import React from 'react';
import PropTypes from 'prop-types';
import { FieldTable } from '../../../components/FieldTable/FieldTable';
import { FieldTableColumnProps } from '../../../components/FieldTable/FieldTableTypes';
import { SiteDigitalBookingPricing } from '../../../generated/graphql';

const columns: FieldTableColumnProps<SiteDigitalBookingPricing>[] = [
    {
        header: 'Days',
        accessor: 'days',
        sort: 'days',
        dataType: 'number',
        width:'full'
    },
    {
        header: 'Net',
        accessor: 'net',
        dataType: 'currency'
    }
];
function newRow() {
    return ({});
}

const DigitalBookingPane = ({ values, setValue, readOnly }) => {
    return (
        <FieldTable columns={columns}
            name="siteDigitalBookingPricing"
            values={values}
            className="site-health-and-safety"
            setValue={setValue}
            newRow={newRow}
            readOnly={readOnly}
            newRowLabel="Add Digital Booking Pricing"
        />
    );
}

DigitalBookingPane.propTypes = {
    health_and_safety: PropTypes.array
};

export default DigitalBookingPane;

